import { T_CONTACT_US_PAGE_CONSTANTS } from './TYPES'

const FR_CONTACT_US_PAGE_CONSTANTS: T_CONTACT_US_PAGE_CONSTANTS = {
  PAGE_KICKER: 'DES QUESTIONS?',
  PAGE_TITLE: 'Contactez-nous',
  THANKYOU_PAGE_TITLE: 'Votre demande a été envoyée avec succès. 🎉',
  GENERIC_ERROR_TOAST_MESSAGE:
    "Une erreur s'est produite. Veuillez réessayer plus tard."
}

export default FR_CONTACT_US_PAGE_CONSTANTS
